// Comprehensive country list with EN and AR labels for the applicant origin
// question. NOT used for nationality/citizenship — this represents the
// country the applicant is coming FROM to attend THE GATHERING. Owner
// directive (Feb 2026). Values in `en` are the canonical string persisted
// to Mongo; the AR label is rendered when the interface language is AR.
export const COUNTRIES = [
  { en: "Saudi Arabia", ar: "السعودية" },
  { en: "United Arab Emirates", ar: "الإمارات" },
  { en: "Kuwait", ar: "الكويت" },
  { en: "Qatar", ar: "قطر" },
  { en: "Bahrain", ar: "البحرين" },
  { en: "Oman", ar: "عُمان" },
  { en: "Yemen", ar: "اليمن" },
  { en: "Jordan", ar: "الأردن" },
  { en: "Egypt", ar: "مصر" },
  { en: "Iraq", ar: "العراق" },
  { en: "Lebanon", ar: "لبنان" },
  { en: "Syria", ar: "سوريا" },
  { en: "Palestine", ar: "فلسطين" },
  { en: "Turkey", ar: "تركيا" },
  { en: "Iran", ar: "إيران" },
  { en: "Sudan", ar: "السودان" },
  { en: "Morocco", ar: "المغرب" },
  { en: "Algeria", ar: "الجزائر" },
  { en: "Tunisia", ar: "تونس" },
  { en: "Libya", ar: "ليبيا" },
  { en: "Mauritania", ar: "موريتانيا" },
  { en: "Djibouti", ar: "جيبوتي" },
  { en: "Somalia", ar: "الصومال" },
  { en: "Comoros", ar: "جزر القمر" },
  { en: "United States", ar: "الولايات المتحدة" },
  { en: "United Kingdom", ar: "المملكة المتحدة" },
  { en: "Canada", ar: "كندا" },
  { en: "Australia", ar: "أستراليا" },
  { en: "New Zealand", ar: "نيوزيلندا" },
  { en: "Germany", ar: "ألمانيا" },
  { en: "France", ar: "فرنسا" },
  { en: "Italy", ar: "إيطاليا" },
  { en: "Spain", ar: "إسبانيا" },
  { en: "Portugal", ar: "البرتغال" },
  { en: "Netherlands", ar: "هولندا" },
  { en: "Belgium", ar: "بلجيكا" },
  { en: "Switzerland", ar: "سويسرا" },
  { en: "Austria", ar: "النمسا" },
  { en: "Sweden", ar: "السويد" },
  { en: "Norway", ar: "النرويج" },
  { en: "Denmark", ar: "الدنمارك" },
  { en: "Finland", ar: "فنلندا" },
  { en: "Ireland", ar: "أيرلندا" },
  { en: "Poland", ar: "بولندا" },
  { en: "Czech Republic", ar: "التشيك" },
  { en: "Greece", ar: "اليونان" },
  { en: "Russia", ar: "روسيا" },
  { en: "Ukraine", ar: "أوكرانيا" },
  { en: "Romania", ar: "رومانيا" },
  { en: "Hungary", ar: "المجر" },
  { en: "China", ar: "الصين" },
  { en: "Japan", ar: "اليابان" },
  { en: "South Korea", ar: "كوريا الجنوبية" },
  { en: "India", ar: "الهند" },
  { en: "Pakistan", ar: "باكستان" },
  { en: "Bangladesh", ar: "بنغلاديش" },
  { en: "Sri Lanka", ar: "سريلانكا" },
  { en: "Nepal", ar: "نيبال" },
  { en: "Afghanistan", ar: "أفغانستان" },
  { en: "Indonesia", ar: "إندونيسيا" },
  { en: "Malaysia", ar: "ماليزيا" },
  { en: "Singapore", ar: "سنغافورة" },
  { en: "Thailand", ar: "تايلاند" },
  { en: "Vietnam", ar: "فيتنام" },
  { en: "Philippines", ar: "الفلبين" },
  { en: "Brazil", ar: "البرازيل" },
  { en: "Argentina", ar: "الأرجنتين" },
  { en: "Mexico", ar: "المكسيك" },
  { en: "Chile", ar: "تشيلي" },
  { en: "Colombia", ar: "كولومبيا" },
  { en: "South Africa", ar: "جنوب أفريقيا" },
  { en: "Nigeria", ar: "نيجيريا" },
  { en: "Kenya", ar: "كينيا" },
  { en: "Ethiopia", ar: "إثيوبيا" },
  { en: "Ghana", ar: "غانا" },
  { en: "Cyprus", ar: "قبرص" },
  { en: "Azerbaijan", ar: "أذربيجان" },
  { en: "Kazakhstan", ar: "كازاخستان" },
  { en: "Uzbekistan", ar: "أوزبكستان" },
  { en: "Other", ar: "دولة أخرى" },
];

// Rev 7.10 (Feb 2026 owner directive):
// Bilingual helpers for the visitor form's country selector. The
// visitor selector reuses the list above, EXCLUDES "Other" (visitors
// must resolve to a real country), and reads/persists the canonical
// English name. Palestine is included by construction (see index 12);
// Israel is intentionally not present in COUNTRIES and must not be
// added. Search matches on either the English or the Arabic name,
// case- and diacritic-insensitive.
export const VISITOR_COUNTRIES = COUNTRIES.filter((c) => c.en !== "Other");

function _normalize(s) {
  return (s || "").toString().toLowerCase().normalize("NFKD")
    .replace(/[\u064b-\u065f\u0670]/g, "")   // strip Arabic tashkeel
    .replace(/[\u0300-\u036f]/g, "")          // strip Latin diacritics
    .trim();
}

export function searchCountries(q) {
  const term = _normalize(q);
  if (!term) return VISITOR_COUNTRIES;
  return VISITOR_COUNTRIES.filter((c) => {
    return _normalize(c.en).includes(term) || _normalize(c.ar).includes(term);
  });
}

// Bilingual display for a stored country string. Historical rows with
// unknown strings render verbatim so the admin panel/export never
// silently relabels submitted data.
export function displayCountry(name, lang = "en") {
  if (!name) return "";
  const c = COUNTRIES.find((x) => x.en === name);
  if (c) return lang === "ar" ? c.ar : c.en;
  return name;
}

export function bilingualCountry(name) {
  const c = COUNTRIES.find((x) => x.en === name);
  if (c) return `${c.en} / ${c.ar}`;
  return name || "";
}
